"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = useDebounce;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

function useDebounce(value, delay) {
  var _React$useState = _react["default"].useState(value),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      debouncedValue = _React$useState2[0],
      setDebouncedValue = _React$useState2[1];

  _react["default"].useEffect(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
//# sourceMappingURL=useDebounce.js.map